import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

// TODO: briefly cut version of Markets document view component. Could (should) be improved.
@Component({
    selector: 'document-view',
    templateUrl: './document-view.component.html',
    styleUrls: ['./document-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DocumentViewComponent {
  // Uint8Array matches both the data passed in (inspection-protocol-loader.pdfSource)
  // and the pdf-viewer [src] input type.
  @Input() document: Uint8Array;
}
